import React, { useRef } from 'react';
import { updateVideoControls } from '@services/sse';
import { useVideoControls } from '@hooks/useVideoControls';
import { useSlideData } from '@context/slide-data';
import { SETTINGS } from '@constants';
import { usePresentation } from '@context/presentation';

export const Video = () => {
    const videoRef = useRef(null);
    const { clientViewing } = usePresentation();
    const { data, slideState } = useSlideData(); 
    const { videoControls } = slideState;
    
    useVideoControls(videoControls, videoRef);

    const handleVideo = async (playing) => {
        await updateVideoControls({
            play: playing,
            pause: !playing
        });
    }

    const handlePlay = async () => {
        await handleVideo(true);
    }

    const handlePause = async () => {
        await handleVideo(false);
    }

    return (
        <video
            data-testid='video'
            onPlay={clientViewing ? null : handlePlay}
            onPause={clientViewing ? null : handlePause}
            ref={videoRef}
            height='100%'
            width='100%' 
            controls>
                <source src={`${SETTINGS.cdnUrl}/tp-videos/${data.videoUrl}.mp4`}  type='video/mp4'/>
                Your browser does not support the video tag.
        </video>
    );
};

export default Video;
